// Canonical trilingual FAQ dataset (single source of truth: faq.json).
// Shared by the FAQ page (visible content), the CMS seed (scripts/build-cms-seed.mjs)
// and the FAQPage JSON-LD, so structured data always matches the on-page text.
// The live data source at runtime is the CMS (`cms.faq`); this module is the
// typed fallback.
import faqData from './faq.json';

export type Lang = 'en' | 'tc' | 'sc';

export interface FaqItem {
  id: string;
  q: Record<Lang, string>;
  a: Record<Lang, string>;
}

export const FAQ_ITEMS: FaqItem[] = faqData as FaqItem[];
